import React, { FC, forwardRef, ReactNode, Ref } from 'react';
import styles from './ActionPopUp.module.scss';
import { CloseImage } from 'static/images';
import clsx from 'clsx';

interface ActionPopUpProps {
  title?: string;
  onClose?: () => void;
  children: ReactNode;
  hideTitle?: boolean;
  className?: string;
}

const ActionPopUp: FC<ActionPopUpProps> = forwardRef(
  ({ onClose, children, title, hideTitle, className }, ref: Ref<HTMLDivElement>) => {
    return (
      <div className={clsx(styles.actionsPopUp, className)} ref={ref}>
        {!hideTitle && (
          <div className={styles.actionsPopUp__header}>
            <p>{title || 'Actions'}</p>
            <button type="button" onClick={onClose}>
              <CloseImage />
            </button>
          </div>
        )}
        <div className={styles.actionsPopUp__body}>{children}</div>
      </div>
    );
  },
);

export default ActionPopUp;
